export default __webpack_public_path__ + "assets/img/user-transparent.fc04cee99299be115f4fdc6ad0c6515a.png";